var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-container"},[_c('LoadingIcon'),_c('img',{attrs:{"src":require("@/assets/icons/logo.png"),"alt":"loading icon"}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }